import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { GeoDataComponent } from './geo-data.component';

const routes: Routes = [{ path: '', component: GeoDataComponent, data: { title: 'GeoData' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GeoDataRoutingModule {}

@NgModule({
  imports: [
    GeoDataRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [GeoDataComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GeoDataModule {}
